import React from "react";
import { Link } from "react-router-dom";
import "./index.scss";

const PremiumBar = () => {
  return (
    <div className="premium-bar">
      <p className="text">
        Experience better farming.{" "}
        <Link
          to="/advanced"
          className="link"
          target="_blank"
          rel="noopener noreferrer"
        >
          Get Advanced
        </Link>
      </p>
    </div>
  );
};

export default PremiumBar;
